import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const headerPadding = {
    paddingTop: isMobile ? '80px' : '3rem',
    paddingBottom: '3rem'
  };

  return (
    <>
      {/* Page Header */}
      <section className="section bg-theme-dark tc-light">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <div className="page-header" style={headerPadding}>
                <h1 className="title title-xl">About EBARANGAY</h1>
                <p className="lead">
                  Transforming barangay governance through innovation, transparency, and accessibility
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="section bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="nk-block-text text-center">
                <h2 className="title mb-4">About Us</h2>
                <p className="lead">
                  EBARANGAY allows residents to obtain barangay-related information at their own convenience without facing geographical or physical limitations. Moreover, the interactive features of EBARANGAY provide benefits for residents and barangay officials alike. Its innovative features aim to transform the barangay on a holistic level and help gear it towards transparency, accountability, and good governance– effectively disseminating barangay information in an efficient manner and making barangay services accessible through the internet and data communication.
                </p>
                <p>
                  EBARANGAY services are primarily categorized into (1) informational services and (2) transactional services. In particular, informational services pertain to the delivery of barangay information through web pages, while transactional services refer to the system’s feature that enables residents to complete barangay-related transactions such as the application for barangay IDs, ayuda tracking, filing of police blotters, and the reporting of incidents or accidents. Couple this with an interface that is user-oriented, EBARANGAY paves a safe and secured online avenue for all barangay-related transactions with the intent of reducing corruption and promoting transparency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose EBARANGAY - Benefits */}
      <section className="section bg-theme tc-light ov-h">
        <div className="container">
          <div className="section-head section-head-sm text-center wide-auto-sm">
            <h2 className="title title-s4" title="Benefits">Why Choose EBARANGAY</h2>
            <p>
              A safe, secured, and user-oriented platform for all barangay transactions promoting transparency and
              accountability
            </p>
          </div>

          <div className="nk-block nk-block-team-list team-list">
            <div className="row justify-content-center">
              <div className="col-lg-3 col-md-6">
                <div className="text-center mb-4">
                  <div className="service-icon mx-auto mb-3">
                    <em className="fas fa-shield-alt fa-3x"></em>
                  </div>
                  <h5 className="title title-sm">Secure & Private</h5>
                  <p>
                    Safe and secured online avenue for all barangay-related transactions with data protection at its
                    core
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="text-center mb-4">
                  <div className="service-icon mx-auto mb-3">
                    <em className="fas fa-clock fa-3x"></em>
                  </div>
                  <h5 className="title title-sm">24/7 Accessibility</h5>
                  <p>Access barangay services and information anytime, anywhere, without geographical limitations</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="text-center mb-4">
                  <div className="service-icon mx-auto mb-3">
                    <em className="fas fa-eye fa-3x"></em>
                  </div>
                  <h5 className="title title-sm">Transparency</h5>
                  <p>Promotes transparency and accountability, reducing corruption and improving governance</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="text-center mb-4">
                  <div className="service-icon mx-auto mb-3">
                    <em className="fas fa-users fa-3x"></em>
                  </div>
                  <h5 className="title title-sm">User-Oriented</h5>
                  <p>Designed with a user-friendly interface accessible to all residents, regardless of expertise</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="text-center mb-4">
                  <div className="service-icon mx-auto mb-3">
                    <em className="fas fa-tachometer-alt fa-3x"></em>
                  </div>
                  <h5 className="title title-sm">Efficiency</h5>
                  <p>Streamlined processes and real-time updates improve service delivery significantly</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="text-center mb-4">
                  <div className="service-icon mx-auto mb-3">
                    <em className="fas fa-mobile-alt fa-3x"></em>
                  </div>
                  <h5 className="title title-sm">Mobile-First</h5>
                  <p>Optimized for mobile devices, allowing residents to access services from smartphones</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section bg-white">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h2 className="title title-lg mb-3">Join the Digital Transformation</h2>
              <p className="lead mb-4">
                Be part of the movement towards better governance. Download EBARANGAY and experience the future of
                barangay services.
              </p>
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=ph.ebarangay.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-lg btn-grad btn-grad-alternet btn-round"
                >
                  <em className="fab fa-google-play me-2"></em>
                  Download Now
                </a>
                <Link to="/services" className="btn btn-lg btn-grad btn-round ms-2">
                  View Services
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
